import Constants from "./Constants";

const BrandUtil = {

    resolveBrand() {
        const host = window.location.hostname;

        if (host.endsWith('.mini.lu') || host.endsWith('.mini.be')) {
            return Constants.BRAND_MINI.value;
        }
      return Constants.BRAND_BMW.value;
    },


};

export default BrandUtil;
